import React from "react";
import PropTypes from "prop-types";
import { Route, Redirect } from "react-router-dom";

const ProtectedRoute = ({
  loggedIn,
  userIsLoading,
  component: Component,
  render: renderFn,
  loginPath,
  ...routeProps
}) => {
  let renderComponent = props => <Component {...props} />;
  let render = renderFn || renderComponent;

  if (userIsLoading) {
    return "User is loading. Please wait...";
  }

  if (!loggedIn) {
    render = props => (
      <Redirect
        to={{ pathname: loginPath, state: { referrer: props.location } }}
      />
    );
  }

  return <Route {...routeProps} render={render} />;
};

ProtectedRoute.propTypes = {
  loggedIn: PropTypes.bool.isRequired,
  userIsLoading: PropTypes.bool.isRequired,
  component: PropTypes.func,
  render: PropTypes.func,
  loginPath: PropTypes.string.isRequired
};

export default ProtectedRoute;
